import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {aShowDialog} from '@modifi/plugin-dialogs'

import BuyerForm, {BuyerFormProps} from './BuyerForm'
import {
  aReset,
  aSavePage,
  selectInitialFormData,
  selectSaveErrorMessage,
  selectSavePending,
  selectSaveHasError,
} from '../store/form'
import {selectSellerTradePartnersCount} from '../../../../../data/seller-trade-partners'
import {ROUTE_INTRO} from '../../../../../routes/constants'
import {PRE_UNDERWRITING_COMPANY_FINANCIALS} from '../../constants'
import {selectBuyerId, aHideBuyerForm} from '../store/view'
import {LIMIT_CONFIRMATION_DIALOG} from '../../../../seller-trade-partners/dialogs'
import {aInitializePage} from '../../../../seller-trade-partners/components/company-data/store'
import {aEnsureFetchCurrenciesByProductType} from '../../../../../data/currencies'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  BuyerFormProps,
  'externalBuyerId' | 'saveErrorMessage' | 'savePending' | 'formData' | 'hasError' | 'buyerCount'
> => {
  const externalBuyerId = selectBuyerId(state)
  return {
    externalBuyerId,
    buyerCount: selectSellerTradePartnersCount(state),
    hasError: selectSaveHasError(state),
    saveErrorMessage: selectSaveErrorMessage(state),
    savePending: selectSavePending(state),
    formData: externalBuyerId
      ? selectInitialFormData(state, externalBuyerId)
      : selectInitialFormData(state),
  }
}

const mapDispatchToProps = {
  initializeDocs: aInitializePage,
  onSubmit: aSavePage,
  onDiscard: aReset,
  redirectToCompanyFinancials: (): any =>
    aPush(ROUTE_INTRO, {page: PRE_UNDERWRITING_COMPANY_FINANCIALS}),
  openLimitConfirmationDialog: (params: Record<string, any>): any =>
    aShowDialog(LIMIT_CONFIRMATION_DIALOG, params),
  fetchCurrencies: aEnsureFetchCurrenciesByProductType,
  hideBuyerForm: aHideBuyerForm,
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyerForm)
